import React, { Component } from "react";
import i18n from "../../i18n";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dashboardActions from "../../redux/actions/dashboardActions";
import * as deviceActions from "../../redux/actions/deviceActions";
import * as usersActions from "../../redux/actions/usersActions";

import { textTranslate } from "../../utils/i18n";

import { DateRangePicker } from "react-dates";
import Select from "react-select";

// React DateRangePicker
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import moment from "moment";
import "moment/locale/da";

import "./SelectDateComp.css";
class SelectDateComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStartDate: 0,
      selectOptions: [
        {
          label: i18n.t("latestDay"),
          value: moment().subtract(1, "days").unix(),
        },
        {
          label: i18n.t("latestWeek"),
          value: moment().subtract(1, "weeks").unix(),
        },
        {
          label: i18n.t("latestMonth"),
          value: moment().subtract(1, "months").unix(),
        },
        {
          label: i18n.t("latestThreeMonths"),
          value: moment().subtract(3, "months").unix(),
        },
        { label: i18n.t("customDateSelector"), value: "custom" },
      ],
      showCustomDateSelector: false,
      focusedInput: null,
      endDate: moment(),
      startDate: moment().subtract(2, "weeks"),
    };
    // this.handleOptionSelect = this.handleOptionSelect.bind(this);

    // utils.bindFunctions.call(this, [
    //   "handleOptionSelect",
    //   "handleDateRangeSelect"
    // ]);
  }

  componentDidMount() {
    //Initial state
    this.setState({
      selectedStartDate: this.state.selectOptions[0],
    });
  }

  handleOptionSelect = (e) => {
    // Update the selected or current sensor ID
    // this.props.handleChangeSelectedStartDate(e.value, this.props.selectedDevices);
    let isCustomDate = !!(e.value === "custom");
    this.setState({
      showCustomDateSelector: isCustomDate,
    });
    // this.props.switchCustomDateRange(isCustomDate);
    if (!isCustomDate && this.state.selectedStartDate.value !== e.value)
      this.props.FetchSelectedDevicesList(e.value, this.props.selectedEndDate, this.props.selectedDevices, this.props.ability);
    this.setState({
      selectedStartDate: this.state.selectOptions.find((opt) => opt.value === e.value),
    });
  };
  componentDidUpdate(prevProps) {
    if (this.props.language !== prevProps.language)
      this.setState({
        selectOptions: [
          {
            label: i18n.t("latestDay"),
            value: moment().subtract(1, "days").unix(),
          },
          {
            label: i18n.t("latestWeek"),
            value: moment().subtract(1, "weeks").unix(),
          },
          {
            label: i18n.t("latestMonth"),
            value: moment().subtract(1, "months").unix(),
          },
          {
            label: i18n.t("latestThreeMonths"),
            value: moment().subtract(3, "months").unix(),
          },
          { label: i18n.t("customDateSelector"), value: "custom" },
        ],
      });
  }
  handleDateRangeSelect = ({ startDate, endDate }) => {
    if (startDate && endDate)
      this.props.FetchSelectedDevicesList(
        startDate.hours(0).minutes(0).seconds(0).milliseconds(0).unix(),
        endDate.hours(24).minutes(59).seconds(59).milliseconds(999).unix(),
        this.props.selectedDevices,
        this.props.ability
      );
    this.setState({ startDate, endDate });
  };
  render() {
    moment.locale(this.props.language);

    let startDate = textTranslate("startDate");
    let endDate = textTranslate("endDate");
    return (
      <div className="d-block">
        <Select
          className="w-100"
          id="dateSelect"
          onChange={this.handleOptionSelect}
          defaultValue={this.state.selectOptions[0]}
          options={this.state.selectOptions}
        />

        {this.state.showCustomDateSelector && (
          <DateRangePicker
            startDatePlaceholderText={startDate}
            endDatePlaceholderText={endDate}
            required={false}
            startDate={this.state.startDate} // momentPropTypes.momentObj or null,
            startDateId="your_unique_start_date_id"
            endDate={this.state.endDate} // momentPropTypes.momentObj or null,
            endDateId="your_unique_end_date_id"
            onDatesChange={({ startDate, endDate }) => this.handleDateRangeSelect({ startDate, endDate })}
            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={(focusedInput) => this.setState({ focusedInput })}
            enableOutsideDays={true}
            anchorDirection="right"
            // orientation={"vertical"}
            openDirection={"down"}
            numberOfMonths={2}
            small
            showDefaultInputIcon
            showClearDates
            block
            isOutsideRange={(day) => day.diff(moment().add(1, "days")) > 0}
            // renderMonthText={month => {
            //   month.locale(this.props.language);
            //   return moment(month).format("MMMM YYYY");
            // }}
            renderDayContents={(day) => {
              day.local(this.props.language);
              return moment(day).format("D");
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // showCustomDateSelector: state.devicesReducer.showCustomDateSelector,
  selectedStartDate: state.dashboardReducer.dashboardReducer,
  selectedDevices: state.devicesReducer.selectedDevices,
  language: state.i18nReducer.language,
  ability: state.usersReducer.ability,
  isFetchingDeviceData: state.devicesReducer.isFetchingDeviceData,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...dashboardActions, ...deviceActions, ...usersActions }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectDateComp);
